// Module
var code = `<!-- ko if: hasParent() && level() >= 1 -->
<a data-bind="click: function(data, event) { \$root.selectCategory(parent()) }" class="block-heading parent-heading" href="#!">
    <span>één niveau omhoog naar</span>
    <h4 data-bind="text: parent().name, attr: {'data-id': parent().id}"></h4>
</a>
<!-- /ko -->

<!-- ko if: level() <= 2 -->
<div class="subcategories">
    <div class="block-heading subcategories-heading">
        Subcategorieën:
    </div>
    <ul data-bind="template: { name: 'nodecat', foreach: subCategories }" class="subcategories-list">
    </ul>
</div>
<!-- /ko -->

${"<" + "script"} type="text/html" id="nodecat">
    <li>
        <label data-bind="attr: { for: \`subcategory-tree-input-\${id}\` }">
            <span data-bind="text: name" class="subcategory-title"></span>
            <span data-bind="text: \`(\${count()})\`" class="filter-count">()</span>
            <input data-bind="value: id, attr: {id: \`subcategory-tree-input-\${id}\`}, checked: \$data.checked, event: {click: \$root.handleSubmit}" name="subcategory" class="hidden" type="checkbox">
        </label>
    </li>
${"<" + "/script"}>
`;
// Exports
module.exports = code;